module.exports = __webpack_public_path__ + "img/Admin.e6864dc1.svg";